module.exports = __webpack_public_path__ + "img/logo-header.088d4157.png";